import axios from "axios";
import { getCookie } from "cookies-next";
import {
  bridgeShowLoader,
  bridgeHideLoader,
} from "@/components/common/global-loader/loading-bridge";

const httpClient = axios.create();

// ── Auth interceptor (existing) ──────────────────────────
httpClient.interceptors.request.use(function (config) {
  const token = getCookie("token");
  const clientId = process.env.NEXT_PUBLIC_LOCAL_CLIENT_ID;

  if (!config.url?.includes("unbxd.io")) {
    config.headers = {
      ...(config.headers || {}),
      "Client-ID": clientId as string,
    };
    if (token && !config.headers["Authorization"]) {
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${token}`,
      };
    }
  }

  return config;
});

// ── Global loader interceptors ───────────────────────────
const isLoaderUrl = (url?: string) => {
  if (!url) return false;
  // Exclude autocomplete/autosuggest so it doesn't block UI while typing
  if (url.includes("autosuggest") || url.includes("autocomplete")) return false;
  // Include Unbxd & Wizzy endpoints (for Load More, filters, etc)
  if (
    url.includes("unbxd.io") ||
    url.includes("wizzy.ai") ||
    url.includes("wizsearch.in")
  ) {
    return true;
  }
  return false;
};

httpClient.interceptors.request.use(
  function (config) {
    if (isLoaderUrl(config.url)) {
      bridgeShowLoader();
    }
    return config;
  },
  function (error) {
    if (isLoaderUrl(error.config?.url)) {
      bridgeHideLoader();
    }
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  function (response) {
    if (isLoaderUrl(response.config.url)) {
      bridgeHideLoader();
    }
    return response;
  },
  function (error) {
    if (isLoaderUrl(error.config?.url)) {
      bridgeHideLoader();
    }
    return Promise.reject(error);
  }
);

export default httpClient;
